import { ReactNode, SVGProps } from "react";
import classNames from "classnames";

import styles from "./index.module.scss";

type PropsType = {
  children: ReactNode;
  onClick?: () => void;
  submit?: boolean;
  ariaLabel?: string;
  loading?: boolean;
  bold?: boolean;
  primary?: boolean;
  secondary?: boolean;
  tertiary?: boolean;
  disabled?: boolean;
  className?: string;
  icon?: SVGProps<SVGSVGElement>;
  form?: string; // For associating a button outside a form with the form
};

const Button = ({
  children, //text
  onClick,
  submit,
  ariaLabel,
  loading,
  bold,
  primary,
  secondary,
  tertiary,
  disabled,
  className,
  icon,
  form,
}: PropsType) => {
  return (
    <button
      className={classNames(className, styles.button, {
        [styles.buttonPrimary]: primary,
        [styles.buttonSecondary]: secondary,
        [styles.buttonTertiary]: tertiary,
        [styles.buttonDisabled]: disabled,
        [styles.textBold]: bold,
      })}
      onMouseDown={(e) => e.preventDefault()} //To prevent :focus on click
      onClick={onClick}
      type={submit ? "submit" : "button"}
      aria-label={ariaLabel}
      disabled={loading || disabled}
      aria-live="polite"
      form={form}
    >
      {loading ? "...Loading" : children}
      {!primary && icon}
      {primary && icon && <div className={styles.circle}>{icon}</div>}
    </button>
  );
};

export default Button;
